import { useQuery } from "@tanstack/react-query";
import { editableTextGet } from "common/api/sakusas/sakusas_editable_text";
import { QUERY_KEYS } from "constant/react_query";

export const useSakusasEditableTextGet = (slug: string) => {
  const { data: editableText } = useQuery(
    [QUERY_KEYS.SAKUSAS_EDITABLE_TEXT_GET, slug],
    async () => {
      const result = await editableTextGet(slug);
      return result;
    },
    { staleTime: Infinity }
  );
  const result =
    typeof editableText !== "undefined" && editableText !== ""
      ? editableText
      : null;
  return result;
};
